/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import PropTypes from 'prop-types';
import { SelectInput } from 'react-admin';
import { ASSET_TYPE_LABEL } from '../models/asset';

const AssetTypeSelectorInput = (props) => {
  let types = [];

  for (const t in ASSET_TYPE_LABEL) {
    types.push({ id: t, name: ASSET_TYPE_LABEL[t] });
  }

  return <SelectInput {...props} choices={types} />;
};

AssetTypeSelectorInput.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
};

AssetTypeSelectorInput.defaultProps = {
  record: {},
};

export default AssetTypeSelectorInput;
